import React,{  useState } from "react";
import { useTokenContext } from "src/account/shared/service/token.context";
import { cn } from "src/shared/utils/props";
import './event-details.module.scss';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { IconButton, Popover } from "@mui/material";
import { format } from "date-fns";
import { bindPopover, bindTrigger, usePopupState } from "material-ui-popup-state/hooks";
import * as Config from 'src/shared/config';
import { format24hto12h } from "src/shared/utils/format";
import { CloseIcon } from "../../../svg";



export const EventDatesListing = ({ eventDates = [], hideTitle = false }) => {
  const { coachTokendecoded } = useTokenContext();
  const currentFranchiseId = coachTokendecoded?.franchiseIds[0];
  const role = coachTokendecoded.role;
  const isAdmin = 5 === role;
  const [viewDetails, setViewDetails] = useState({});
  const adminUrl = Config.ADMIN_URLS[ENVIRONMENT];

  const toggleViewDetail = (id) => {
    setViewDetails((previous) => ({
      ...previous,
      [id]: !previous[id],
    }));
  };

  return (
    <div className="conflictingModal">
      {!hideTitle && <p className="title">Conflicts</p>}
      <div className="datesList">
        <div className={cn("item", "header")}>
          <p>Location</p>
          <p>Program</p>
          <p>Date & Times</p>
          <p>Staff</p>
        </div>
        {eventDates?.map((eventDate) => {
          const { scheduledTimeOff } = eventDate;
          const isTimeOff = Boolean(eventDate?.scheduledTimeOffId);
          const location = eventDate?.overriddenLocation?.id
            ? eventDate?.overriddenLocation
            : eventDate?.event?.location;
          const program = eventDate?.event?.program;
          const { event: cls, id } = eventDate;
          const eventFranchise = cls?.franchise || {};
          const isCurrentFranchiseEvent =
            Number(currentFranchiseId) === Number(eventFranchise?.id) || false;
          const canAccessData =
            isAdmin || isCurrentFranchiseEvent 
          const {
            address: locationAddress,
            city = "",
            name: locationName,
            state = "",
            zipcode = "",
          } = location || {};
          const locationCityState = `${city}, ${state} ${zipcode}`;
          const existingStartTime = eventDate?.startTime || cls.startTime;
          const existingEndTime = eventDate?.endTime || cls.endTime;
          const isDetailVisible = viewDetails[id];

          return (
            <div className="item" key={id}>
              <div>
                {isTimeOff && (
                  <div
                    css={(theme) => ({
                      color: theme.palette.error.main,
                      fontWeight: "bold",
                      marginBottom: theme.spacing(0.5),
                    })}
                  >
                    Scheduled Time Off
                  </div>
                )}
                {location?.id && (
                  <>
                    <div
                      css={(theme) => ({
                        color: theme.palette.error.main,
                        fontWeight: "bold",
                        marginBottom: theme.spacing(0.5),
                      })}
                    >
                      {canAccessData ? (
                        <a
                          href={`${adminUrl}/locations/${location?.id}/edit`}
                          rel="noreferrer"
                          target="_blank"
                        >
                          {locationName}
                        </a>
                      ) : (
                        locationName
                      )}
                    </div>

                    <div>
                      <div>{locationAddress},</div>
                      <div>{locationCityState}</div>
                    </div>
                  </>
                )}
              </div>
              <div>
                {!isCurrentFranchiseEvent && (
                  <div className="tw-flex tw-justify-between tw-w-full">
                    <span className="tw-bg-[#f2e9c0] tw-px-3 tw-py-1 tw-whitespace-nowrap tw-overflow-hidden tw-text-ellipsis">
                      {isTimeOff
                        ? `${scheduledTimeOff?.category.name}`
                        : `Staffed to ${eventFranchise?.name}`}
                    </span>
                    {!canAccessData && (
                      <span
                        className="tw-text-[10px] tw-self-end tw-text-cyan-700 tw-underline tw-cursor-pointer"
                        onClick={() => toggleViewDetail(id)}
                      >
                        {isDetailVisible ? "Hide details" : "View details"}
                      </span>
                    )}
                  </div>
                )}
                {!isTimeOff && (canAccessData || isDetailVisible) && (
                  <>
                    <div
                      style={{
                        alignItems: "center",
                        display: "flex",
                      }}
                    >
                      {canAccessData ? (
                        <>
                          <a
                            css={{
                              fontSize: 11,
                              lineHeight: 1.2,
                              padding: 0,
                            }}
                           href={`${adminUrl}/classes/${event?.code}/edit`}
                            rel="noopener noreferrer"
                            size="small"
                            target="_blank"
                            variant="text"
                          >
                            {cls?.label}
                          </a>
                          <a
                           href={`${adminUrl}/classes/${event?.code}/edit`}
                            rel="noreferrer"
                            style={{
                              marginLeft: "3px",
                              marginTop: "2px",
                            }}
                            target="_blank"
                          >
                            <ArrowForwardIcon style={{ fontSize: "12px" }} />
                          </a>
                        </>
                      ) : (
                        cls?.label
                      )}
                    </div>

                    <div css={{ fontWeight: "bold" }}>
                      {program?.name ? program?.name : "No Program"}
                    </div>

                    <div>
                      <span>Ages: </span>
                      {cls?.ageRangeLabel}
                    </div>
                    {(cls?.startTime || cls?.endTime) && (
                      <div>
                        <span>
                          {format24hto12h(cls?.startTime)} -{" "}
                          {format24hto12h(cls?.endTime)}
                        </span>
                      </div>
                    )}

                    <div>
                      <span>Class ID: </span>
                      <span>{cls?.id}</span>
                    </div>
                  </>
                )}
              </div>

              <div>
                <p>
                  {format(
                    typeof eventDate?.startDateTimeInUTC === "string"
                      ? new Date(eventDate?.startDateTimeInUTC)
                      : eventDate?.startDateTimeInUTC,
                    "MMMM dd, yyyy"
                  )}
                  <span
                    style={{
                      marginLeft: "5px",
                      marginRight: "5px",
                    }}
                  >
                    {format24hto12h(existingStartTime)} -{" "}
                    {format24hto12h(existingEndTime)}{" "}
                  </span>
                </p>
                {!isTimeOff && (
                  <span>
                    Event Date ID: <span>{eventDate?.id}</span>
                  </span>
                )}
              </div>
              <div>
                <div>
                  {eventDate?.staffAssignments?.map((staff) => {
                    return (
                      <div key={staff?.assigneeId}>
                        <span>
                          {staff?.fullName} ({staff?.roleType})
                        </span>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export const EventDateConflicts = ({
  coachId,
  coachesConflicts,
  eventDateId,
  fontSize = 12,
}) => {
  const coachConflicts = coachesConflicts[coachId];

  const popupState = usePopupState({
    popupId: `popover-${coachId}-${eventDateId}`,
    variant: "popover",
  });
  if (!coachConflicts?.conflictingDates?.length) {
    return null;
  }
  return (
    <>
      <div
        className="conflictingContainer"
        style={{
          fontSize: `${fontSize}px`,
        }}
      >
        <span className="subText">Conflicts:</span>

        <span className="conflictingText" {...bindTrigger(popupState)}>
          {coachConflicts?.conflictingDates.length} /{" "}
          {coachConflicts?.totalDates}
        </span>
      </div>

      <Popover
        disableEnforceFocus
        {...bindPopover(popupState)}
        anchorOrigin={{
          horizontal: "center",
          vertical: "bottom",
        }}
        transformOrigin={{
          horizontal: "center",
          vertical: "top",
        }}
      >
        <div className="popoverContentWrapper">
          <div className="closeButton">
            <IconButton color="inherit" edge="end" onClick={popupState.close}>
              <CloseIcon />
            </IconButton>
          </div>
          <EventDatesListing
            eventDates={coachConflicts?.conflictingDates || []}
          />
        </div>
      </Popover>
    </>
  );
};

